export const UNIFIED_DIGEST_TIMEFRAMES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const;

export const UNIFIED_DIGEST_DEFAULT_TIMEFRAME = UNIFIED_DIGEST_TIMEFRAMES.DAILY;
export const UNIFIED_DIGEST_ACTIVE_JOB_ROUTE_SEGMENT = 'active';

export const UNIFIED_DIGEST_SCOPE_MODES = {
  CHAT_SPACES: 'chat_spaces',
} as const;

export const UNIFIED_DIGEST_ACTION_ITEM_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in-progress',
  DONE: 'done',
  BLOCKED: 'blocked',
  UNKNOWN: 'unknown',
} as const;

export const UNIFIED_DIGEST_ACTION_ITEM_PRIORITY = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  NONE: 'none',
} as const;

export const UNIFIED_DIGEST_SUMMARY_SECTION_IDS = {
  DIGEST_OVERVIEW: 'digest-overview',
  CHAT: 'chat',
  EMAIL: 'email',
  MEETINGS: 'meetings',
  ACTION_ITEMS: 'action-items',
  REMINDERS: 'reminders',
  THEMES: 'recurring-themes',
  BLOCKERS: 'blockers',
} as const;

export const UNIFIED_DIGEST_DIGEST_SOURCE = {
  GOOGLE_CHAT: 'google-chat',
  GMAIL: 'gmail',
  GOOGLE_MEET: 'google-meet',
  GOOGLE_CALENDAR: 'google-calendar',
  MEMORY: 'memory',
  PROJECT_MANAGEMENT: 'project-management',
  HANA_ACTION: 'hana-action',
  HANA_DIGEST: 'hana-digest',
} as const;

export const UNIFIED_DIGEST_SECTION_ORDER: string[] = [
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.DIGEST_OVERVIEW,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.CHAT,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.EMAIL,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.MEETINGS,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.ACTION_ITEMS,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.REMINDERS,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.THEMES,
  UNIFIED_DIGEST_SUMMARY_SECTION_IDS.BLOCKERS,
];

export const UNIFIED_DIGEST_SECTION_SOURCE_LIMIT = 5;

export const UNIFIED_DIGEST_SEARCH_INPUT_DEBOUNCE_MS = 400;

export const UNIFIED_DIGEST_LOADING_MESSAGE =
  'We are assembling your latest updates. This may take a few moments.';

export const UNIFIED_DIGEST_REFRESH_IN_PROGRESS_MESSAGE =
  'We are regenerating the digest. You can keep using the dashboard while we finish.';

export const UNIFIED_DIGEST_JOB_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETE: 'complete',
  FAILED: 'failed',
} as const;

export const UNIFIED_DIGEST_JOB_STATUS_POLL_INTERVAL_MS = 5000;

export const UNIFIED_DIGEST_JOB_POLLING_ACTIVE_MESSAGE =
  'We are preparing the latest summary. Keep this page open and we will refresh automatically.';

export const UNIFIED_DIGEST_JOB_FAILURE_MESSAGE =
  'We were unable to generate the latest summary. Please try again.';

export const UNIFIED_DIGEST_HISTORY_LIMIT = 10;
export const UNIFIED_DIGEST_SEARCH_PAGE_SIZE = 10;

export const UNIFIED_DIGEST_DAILY_DEFAULT_WEEKDAYS = [1, 2, 3, 4, 5] as const;

export const UNIFIED_DIGEST_EMAIL_PLAN_CAPABILITIES = {
  FREE: {
    maxDailySendWeekdays: 7,
    allowsRecurringEmail: false,
  },
  BASIC: {
    maxDailySendWeekdays: 7,
    allowsRecurringEmail: true,
  },
  PRO: {
    maxDailySendWeekdays: 7,
    allowsRecurringEmail: true,
  },
} as const;

export const UNIFIED_DIGEST_MONTHLY_LIMIT_ERROR_CODE =
  'UNIFIED_DIGEST_MONTHLY_LIMIT_REACHED';
